import * as Sentry from '@sentry/vue'
import store from '@/vuex/store'

const MESSAGE_TYPES = {
  ANNOTATIONS_UPDATED: 'annotationsUpdated',
}

/**
 * Handles annotation update events from the server
 * @param {Array} data - Annotation data from the server
 */
export function handleAnnotationUpdated(data) {
  try {
    // Validate data
    if (!Array.isArray(data) || data.length === 0) return

    // Check if the feature is enabled
    if (!store.getters['slideAnnotations/canUseSlideAnnotations']) return

    // Update annotations in store with the simplified format
    store.commit('slideAnnotations/SET_ANNOTATIONS', {
      annotations: data,
    }, { root: true })

    // Use the safe action that will check if presentation slides are ready
    // and retry if necessary
    store.dispatch('slideAnnotations/safelyHandleAnnotationSyncAction', null, { root: true })
  } catch (error) {
    Sentry.captureException(error)
  }
}

// Export handlers mapped to message types
const SlideAnnotationsWebsocketSubscriber = {
  [MESSAGE_TYPES.ANNOTATIONS_UPDATED]: handleAnnotationUpdated,
}

export default SlideAnnotationsWebsocketSubscriber
